export interface Project {
  id: number;
  title: string;
  location: string;
  category: 'Film' | 'Photography' | 'Commercial' | 'Lifestyle' | 'Fashion';
  image: string;
  videoId?: string; // Video ID
  videoPlatform?: 'youtube' | 'vimeo';
  description?: string;
}

export enum SectionId {
  HERO = 'hero',
  WORK = 'work',
  GALLERY = 'gallery',
  PHILOSOPHY = 'philosophy',
  CONTACT = 'contact'
}